<button
  style="position: absolute; top: 10px; right: 10px; display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
  onmouseover="this.style.background='#f3f4f6'"
  onmouseout="this.style.background='white'"
  (click)="close()"
>Cerrar</button>
<br>
<mat-tab-group class="m-4">
  <mat-tab label="Datos Generales">
    <mat-card *ngIf="pagador" class="mt-4 w-full">
      <mat-card-content>
        <div
          style="background:#f0f5f2;border-left:4px solid #1e5a3f;padding:10px 14px;border-radius:8px;margin-bottom:16px;font-size:0.9rem;"
        >
          <span class="font-semibold" style="color:#1e5a3f;">Cliente que solicitó: </span>
          <ng-container *ngIf="pagador.usuario">
            {{ pagador.usuario.nombre }} {{ pagador.usuario.apellidos }}
            <span *ngIf="pagador.usuario.email"> · {{ pagador.usuario.email }}</span>
            <span *ngIf="pagador.usuario.numeroId"> · {{ pagador.usuario.numeroId }}</span>
          </ng-container>
          <ng-container *ngIf="!pagador.usuario">ID {{ pagador.usuarioId }}</ng-container>
          <!-- Sin el sello "Validado por RegCheq" (P2): en los pagadores viejos con
               fuente 2 hacía parecer revisado algo que nadie aprobó. -->
        </div>
        <!-- Link permanente: marcas del registro para revisar antes de aprobar (no bloquean). -->
        <div *ngIf="registroPorLinkPermanente"
          style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:10px 14px;margin-bottom:16px;font-size:0.85rem;">
          <span class="font-semibold">Registrado por el link permanente del cliente.</span>
          <span *ngIf="emailVerificadoLink"> Email verificado: {{ emailVerificadoLink }}.</span>
          <div *ngIf="alertasLink.length"
            style="display:flex;align-items:flex-start;gap:8px;background:#fef3c7;border:1px solid #fcd34d;border-radius:8px;padding:8px 12px;margin-top:8px;">
            <mat-icon style="font-size:18px;width:18px;height:18px;color:#b45309;flex-shrink:0;">warning</mat-icon>
            <div style="color:#78350f;line-height:1.4;">
              Revisa con más cuidado antes de aprobar:
              <ul style="margin:4px 0 0;padding-left:18px;">
                <li *ngFor="let a of alertasLink">{{ a }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <span class="font-semibold"> Nombre: <br /></span>
            {{ pagador.nombre }}
          </div>
          <div *ngIf="pagador.tipoUsuarioId===0">
            <span class="font-semibold"> Apellidos: <br /></span>
            {{ pagador.apellidos }}
          </div>
          <div>
            <span class="font-semibold"> Documento: <br /></span>
            {{ pagador.tipoId }} {{ pagador.numeroId }}
          </div>
          <div *ngIf="pagador.tipoUsuarioId===0">
            <span class="font-semibold"> Fecha de nacimiento: <br /></span>
            {{ pagador.fechaNacimiento }}
          </div>
          <div>
            <span class="font-semibold"> Teléfono: <br /></span>
            {{ pagador.prefijoTelefono }} {{ pagador.telefono }}
          </div>
          <div *ngIf="pagador.tipoUsuarioId===0">
            <span class="font-semibold"> Nacionalidad: <br /></span>
            {{ pagador.nacionalidad }}
          </div>

          <div *ngIf="pagador.tipoUsuarioId===0">
            <span class="font-semibold"> País residencia: <br /></span>
            {{ pagador.paisResidencia }}
          </div>
          <div *ngIf="pagador.tipoUsuarioId===0">
            <span class="font-semibold"> Profesion: <br /></span>
            {{ pagador.profesion }}
          </div>
        </div>

        <div class="mt-4 w-full flex flex-col items-center">
          <ng-container *ngIf="mostarFrontal">
            <h2 class="font-bold text-lg">Documento identidad frontal:</h2>
            <img class="w-full sm:w-4/6 md:w-1/2" [src]="fotoIdFrontal" />
          </ng-container>
          <ng-container *ngIf="!mostarFrontal">
            <h2 class="font-bold text-lg">Documento identidad posterior:</h2>
            <img class="w-full sm:w-4/6 md:w-1/2" [src]="fotoIdPosterior" />
          </ng-container>
          <div>
            <button
              class="mt-4"
              style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'"
              onmouseout="this.style.background='#1C593D'"
              (click)="mostarFrontal = !mostarFrontal"
            >
              <mat-icon>rotate_right</mat-icon>
              Girar
            </button>
          </div>
          <div class="mt-4 w-full flex flex-col items-center" *ngIf="selfie">
            <h2 class="font-bold text-lg">Selfie:</h2>
            <div *ngIf="selfieDesdeArchivo"
              style="display: flex; align-items: flex-start; gap: 8px; background: #fef3c7; border: 1px solid #fcd34d; border-radius: 10px; padding: 8px 12px; margin: 6px 0 10px; max-width: 560px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #b45309; flex-shrink: 0;">warning</mat-icon>
              <span style="font-size: 0.8rem; color: #78350f; line-height: 1.4;">
                Esta selfie entró por el respaldo de archivo del registro por link: puede ser una foto de la galería y no una
                tomada en el momento. Compárala con el documento con más cuidado antes de aprobar.
              </span>
            </div>
            <img class="w-full sm:w-4/6 md:w-1/2" [src]="selfie" />
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-tab>
  <mat-tab label="KYC">
    <mat-card *ngIf="pagador" class="mt-4">

     <mat-card-content>

        <div>
          <form
            class="grid grid-cols-1 md:grid-cols-2 gap-4"
            [formGroup]="formCompliance"
            *ngIf="formCompliance"
          >
            <div class="grid grid-cols-1">
              <div>
                <span class="font-semibold"> Estado Compliance: <br /></span>
                {{pagador.estadoCompliance.descripcion}}
              </div>
              <div *ngIf="pagador.estadoComplianceID === 4"
                style="display: flex; align-items: flex-start; gap: 8px; background: #ede9fe; border: 1px solid #c4b5fd; border-radius: 10px; padding: 10px 14px; margin-top: 10px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6d28d9; flex-shrink: 0;">block</mat-icon>
                <span style="font-size: 0.8rem; color: #4c1d95; line-height: 1.4;">
                  Pagador <strong>BLOQUEADO</strong>: no recibe abonos y no cuenta en las validaciones de RUT.
                  Para desbloquearlo, apruébalo, recházalo o pásalo a blacklist (solo si su documento no es ya de un cliente u otro pagador).
                  El motivo está en el historial (log).
                </span>
              </div>
              <div class="flex flex-row flex-wrap gap-4">
                <button
                  class="mt-4"
                  style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#059669'"
                  onmouseout="this.style.background='#1C593D'"
                  (click)="aproveCompliance()" [disabled]="pagador.estadoComplianceID === 3"
                >
                  <mat-icon>check</mat-icon>
                  Aprobar
                </button>
                <button
                  class="mt-4"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#b91c1c'"
                  onmouseout="this.style.background='#dc2626'"
                  (click)="rejectUser()"
                  [disabled]="pagador.estadoComplianceID === 1"
                >
                  <mat-icon>cancel</mat-icon>
                  Rechazar
                </button>
                <button
                  class="mt-4"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#b91c1c'"
                  onmouseout="this.style.background='#dc2626'"
                  [disabled]="pagador.estadoComplianceID === 2"
                  (click)="backlistUser()"
                >
                  <mat-icon>error</mat-icon>
                  Black list
                </button>
                <button
                  type="button"
                  class="mt-4"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #6d28d9; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#5b21b6'"
                  onmouseout="this.style.background='#6d28d9'"
                  [disabled]="pagador.estadoComplianceID === 4"
                  (click)="bloquearPagador()"
                >
                  <mat-icon>block</mat-icon>
                  Bloquear
                </button>
                <button
                  type="button"
                  class="mt-4"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#f3f4f6'"
                  onmouseout="this.style.background='white'"
                  [disabled]="pagador.activo === false"
                  (click)="darDeBaja()"
                >
                  <mat-icon>person_remove</mat-icon>
                  Dar de baja
                </button>
              </div>
            </div>
            <div>
              <p>
                <mat-checkbox formControlName="politicamenteExpuesto"
                  >PEP</mat-checkbox
                >
              </p>
              <p><mat-checkbox formControlName="esRTP">RTP</mat-checkbox></p>
              <p>
                <mat-checkbox formControlName="esListaONU"
                  >LISTA ONU</mat-checkbox
                >
              </p>
              <mat-hint class="text-sm" *ngIf="pagador.fuenteComplianceID === 2">
                *Valores iniciales traídos de RegCheq: revísalos antes de aprobar. Se guardan al aprobar.
              </mat-hint>

              <!-- Validación PEP Chile (obligatoria antes de aprobar) -->
              <div *ngIf="esCL" class="mt-3" style="border-top:1px solid #e5e7eb;padding-top:10px;">
                <span class="font-semibold" style="display:block;margin-bottom:6px;">Validación PEP Chile (RegCheq)</span>
                <div *ngIf="pepChileLoading" style="color:#6b7280;">Consultando PEP…</div>
                <div
                  *ngIf="!pepChileLoading && pepChileResult"
                  [style.color]="pepChileResult.isPep ? '#c0392b' : '#1e5a3f'"
                  style="font-weight:600;"
                >
                  {{ pepChileResult.isPep ? '⚠️ Figura como PEP' : '✓ No figura como PEP' }}
                  <span *ngIf="pepChileResult.isFuncionarioPublico" style="font-weight:400;"> · Funcionario público</span>
                  <span *ngIf="pepChileResult.effectiveRisk" style="font-weight:400;"> · Riesgo: {{ pepChileResult.effectiveRisk }}</span>
                </div>
                <div *ngIf="!pepChileLoading && pepChileError" style="color:#c0392b;">{{ pepChileError }}</div>
                <button
                  type="button"
                  class="mt-2"
                  [disabled]="pepChileLoading"
                  style="display:inline-flex;align-items:center;gap:6px;padding:6px 18px;background:#1C593D;color:white;border:none;border-radius:8px;font-weight:600;font-size:0.8rem;cursor:pointer;"
                  (click)="checkPepChile()"
                >
                  <mat-icon>refresh</mat-icon>
                  Revalidar PEP
                </button>
              </div>
              <div>
                <button
                  class="mt-4"
                  style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#059669'"
                  onmouseout="this.style.background='#1C593D'"
                  (click)="guardarCompliance()"
                >
                  <mat-icon>check</mat-icon>
                  Guardar
                </button>
              </div>

            </div>
          </form>


        </div>
      </mat-card-content>
    </mat-card>

    <div></div>
  </mat-tab>
  <mat-tab label="Datos Residenciales" *ngIf="pagador?.tipoUsuarioId===0">
    <mat-card *ngIf="pagador" class="mt-4">
      <mat-card-content>
        <div class="grid grid-cols-1 gap-4">
          <div>
            <span class="font-semibold"> País residencia: <br /></span>
            {{ pagador.paisResidencia }}
          </div>
          <div>
            <span class="font-semibold"> Ciudad de residencia: <br /></span>
            {{ pagador.ciudadResidencia }}
          </div>
          <div>
            <span class="font-semibold"> Dirección: <br /></span>
            {{ pagador.direccion }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div></div>
  </mat-tab>
  <mat-tab label="Datos Empresariales" *ngIf="pagador?.tipoUsuarioId===1">
  <mat-card-content>

    <div class="datos grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      <div>
        <span class="font-semibold"> Razon Social: <br /></span>
        {{ pagador?.razonSocial }}
      </div>
      <div>
        <span class="font-semibold"> Rut: <br /></span>
        {{ pagador?.rutEmpresa }}
      </div>
      <div>
        <span class="font-semibold"> Nombre Comercial: <br /></span>
        {{ pagador?.nombreComercial }}
      </div>
      <div>
        <span class="font-semibold"> Domicilio Fiscal: <br /></span>
        {{ pagador?.domicilioFiscal }}
      </div>
    </div>

    <div class="documentos">
      <mat-card *ngIf="pagador" class="mt-4">
        <div class="mt-4 w-full flex flex-col items-center">
          <ng-container *ngIf="pagador.estatuto">
            <button
              style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'"
              onmouseout="this.style.background='#1C593D'"
              (click)="downloadPDF(estatuto)" class="my-4">Descargar Estatuto</button>
          </ng-container>
          <ng-container *ngIf="pagador.e_rut">
            <button
              style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'"
              onmouseout="this.style.background='#1C593D'"
              (click)="downloadPDF(erut)" class="my-4">Descargar Rut</button>
          </ng-container>
          <ng-container *ngIf="pagador.documentoId">
            <button
              style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'"
              onmouseout="this.style.background='#1C593D'"
              (click)="downloadPDF(documentoIdTributario)" class="my-4">Descargar Documento ID Tributario</button>
          </ng-container>
        </div>
      </mat-card>
    </div>

  </mat-card-content>
  </mat-tab>
</mat-tab-group>
